"use client";

import { useState, useEffect } from "react";

const STORAGE_KEY = "hearnow_do_not_share";

export default function Dsmi() {
  const [doNotShare, setDoNotShare] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // 从 localStorage 读取保存的值
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved !== null) {
      setDoNotShare(saved === "true");
    }
    setMounted(true);
  }, []);

  const handleChange = (checked: boolean) => {
    setDoNotShare(checked);
    localStorage.setItem(STORAGE_KEY, String(checked));
  };

  return (
    <div className="bg-gradient-to-br from-purple-50 via-white to-indigo-50 min-h-screen text-gray-800">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white/90 shadow-xl p-8 md:p-10 border border-gray-100 rounded-lg animate-fade-in">
          <h2 className="text-4xl font-bold mb-4 text-[#293c58]">
            Your Privacy Choices
          </h2>
          <p className="text-[#293c58] text-sm mb-6">Last Updated: January 22, 2026</p>

          <div className="text-gray-700 space-y-4 leading-relaxed">
            <p>
              Depending on what state you live in, you may have the right to opt out
              of "sales" of your personal information, sharing of personal
              information for cross-contextual behavioral advertising ("sharing"),
              or "processing of personal data for targeted advertising" as defined
              in applicable privacy law. Please read below for more information
              about these activities and how to opt out.
            </p>

            <p>
              We do not sell personal information for monetary consideration, but we
              may disclose your information to third-party partners (including
              through the use of tracking technologies such as cookies and pixels)
              for the purpose of tailoring and displaying relevant advertisements to
              you on our site and on other platforms, as well as analyzing our
              advertising efforts.
              <strong className="block mt-2">
                This data we may disclose does not identify you by name or other
                directly identifiable means.
              </strong>
              Rather, it is about the basic information related to your browser,
              device identifiers, your general location, and the content and
              advertising you view on our site and mobile application. However, as
              further described in our{" "}
              <a href="/hear_now/privacy" className="text-purple-600 hover:text-purple-800 underline">
                Privacy Policy
              </a>
              , these types of disclosures may constitute "sales," "sharing," or
              "processing of personal data for targeted advertising" under certain
              US state privacy laws.
            </p>

            <p>
              <strong>
                If your state provides you with the right to opt out of "selling,"
                "sharing," or "processing of personal data for targeted advertising"
                and you would like to exercise these rights, please check the box
                titled "Do Not Share My Information" below.
              </strong>{" "}
              Please note that opting out does not mean that you will stop seeing
              all ads.
            </p>

            <div className="mt-6 p-4 bg-purple-50 rounded-lg border border-purple-100">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={mounted ? doNotShare : false}
                  onChange={(e) => handleChange(e.target.checked)}
                  className="w-5 h-5 rounded border-purple-300 text-purple-600 focus:ring-purple-500 cursor-pointer"
                />
                <span className="font-semibold text-[#293c58]">Do Not Share My Information</span>
              </label>
              {mounted && doNotShare && (
                <p className="mt-2 text-sm text-green-600">
                  ✓ Your preference has been saved.
                </p>
              )}
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                For more information about how we handle your personal data, please review our{" "}
                <a href="/hear_now/privacy" className="text-purple-600 hover:text-purple-800 underline">
                  Privacy Policy
                </a>{" "}
                or contact us at{" "}
                <a href="mailto:privacy@hearnow.com" className="text-purple-600 hover:text-purple-800 underline">
                  privacy@hearnow.com
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
